import { Link, Outlet } from 'react-router-dom';
import { Logo } from '@/components/layout/Logo';
import { ThemeToggle } from '@/components/layout/ThemeToggle';
import { UserMenu } from '@/components/auth/UserMenu';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Marketing shell for the landing page and for the one page a guest can
 * reach without signing in: their own analysis result.
 *
 * The header and footer rows are boxed to the same max width as the page
 * content below them, instead of spanning the full viewport - on wide
 * monitors that made the nav bar feel stretched out of proportion with the
 * (already constrained) content.
 */
export function PublicLayout() {
  const isAuthenticated = useAuthStore((state) => state.status === 'authenticated');

  return (
    <div className="flex min-h-screen flex-col items-center bg-bg">
      <header className="flex h-14 w-full max-w-[1400px] shrink-0 items-center justify-between border-b border-border px-4 sm:px-6">
        <Link to="/" aria-label="Design MD Generator home">
          <Logo />
        </Link>
        <div className="flex items-center gap-2">
          {isAuthenticated ? (
            <Link
              to="/dashboard"
              className="rounded-md px-3 py-1.5 text-sm text-muted transition-colors hover:bg-surface-hover hover:text-fg"
            >
              Dashboard
            </Link>
          ) : null}
          <UserMenu />
          <ThemeToggle />
        </div>
      </header>
      <main id="main" className="w-full flex-1">
        <Outlet />
      </main>
      <footer className="w-full max-w-[1400px] border-t border-border px-4 py-6 text-center text-xs text-subtle sm:px-6">
        Extracts a public site&apos;s visual language into design tokens. It does not copy source
        code, markup or brand assets.
      </footer>
    </div>
  );
}
